import { createContext, useContext } from "react";
import { usePassengers } from "../hooks";
const Context = createContext();

export const PassengersProvider = ({ children }) => {
  return (
    <Context.Provider value={usePassengers()}>{children}</Context.Provider>
  );
};

export const usePassengersContext = () => useContext(Context);
